export default __webpack_public_path__ + "static/BitterRegular-a3ca591980bea876ed4af2ac8e784358.ttf";